module.exports = __webpack_public_path__ + "images/ufo.8c27673cdb57e1aa5b4c706bf7bb42f5.svg";